import Page from './sucesso-campanha'
export default Page
